import React from 'react';
import { Container, Header, Divider, Content, Footer, Row, Col, RadioGroup, Radio, Icon, Steps, Panel, SelectPicker } from 'rsuite';
import { Link } from 'react-router-dom';
import shortcuts from '../utils/shortcuts';
import * as firebase from 'firebase/app';
import 'firebase/analytics';
import { ChatMeTwitter } from '../components/ChatMeTwitter';
import { PrivacyLink } from '../components/PrivacyLink'

export class ShortcutScreen extends React.Component {
    constructor() {
        super()
        this.state = {
            typeOfShortcut: 'notification',
            value: null
        }
        this.handleChange = this.handleChange.bind(this);
    }

    Card = props => {
        return (
            <Panel bordered {...props} onClick={() => this.driveToShortcut(props.link, props.header)} header={props.header}>
            </Panel>
        )
    }

    driveToShortcut = (value, item) => {

        let country = item + ' shortcut'
        firebase.analytics().logEvent(country)
        const win = window.open(value, '_blank')
        win.focus();
    }

    compare(a, b) {
        let nameA = a.substring(0, a.length - 1);
        let nameB = b.substring(0, b.length - 1);
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    }

    handleChange(value) {
        this.setState({
            value
        });
    }

    changeTypeOfShortcut = value => {
        this.setState({
            typeOfShortcut: value,
            value: null
        }, () => {
            console.log(this.state)
        })
    }

    render() {
        return (
            <Container>
                <Header className="header">
                    <h1>I hate Coronavirus </h1>
                    <span className="emoji">🦠</span>

                </Header>
                <Divider />
                <Content>
                    <Row >
                        <Col>
                            <div>
                                <Link className="back-to-home-link" style={{ color: 'white', display: 'flex', alignItems: 'center', textDecoration: 'none' }} to="/">
                                    <Icon size="lg" icon="arrow-left-line" style={{ paddingRight: 10 }} /><span className="back-to-home-text">Want some real-time statistics and news?</span>
                                </Link>
                            </div>
                        </Col>
                    </Row>
                    <div className="shortcut-header-row">
                        <div className="shortcut-image-col">
                            <img className="shortcut-sample-image" src="https://hatecoronavirus.web.app/shortcut.png" alt="shortcut-sample" />
                        </div>
                        <div className="shortcut-text-col">
                            <h3 className="medium-title">Get your Apple shortcut</h3>
                            <div className="shortcut-subtitle">Get worldwide or country-based statistics about Coronavirus with just a click</div>
                            <Steps small vertical style={{ paddingTop: 20 }}>
                                <Steps.Item status="wait" title="Choose if you want to recieve notifications or alerts" />
                                <Steps.Item status="wait" title="Click on the shortcut that you prefer" />
                                <Steps.Item title="Add it to your Apple shortcuts" />
                                <Steps.Item style={{ paddingBottom: 0 }} title="Done! Activate it whenever you want stats!" />
                            </Steps>

                        </div>
                    </div>
                    <Row>
                        <Col>
                            <h3 style={{ textAlign: 'center', paddingTop: 40 }} className="medium-title">Choose shortcut!</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{ display: 'flex', justifyContent: 'center', paddingTop: 20 }}>
                            <RadioGroup name="radioList" onChange={value => this.changeTypeOfShortcut(value)} defaultValue={this.state.typeOfShortcut} inline>
                                <Radio value="notification">Notification</Radio>
                                <Radio value="alert">Alert</Radio>
                            </RadioGroup>
                        </Col>
                    </Row>
                    <div className="shortcut-content-row">
                        <div className="shorcut-select-world-container">
                            <SelectPicker sort={isGroup => {
                                return (a, b) => {
                                    return this.compare(a.label, b.label);
                                };
                            }} maxHeight={150} onChange={this.handleChange}  value={this.state.value} placeholder="Select your country" data={shortcuts} valueKey={this.state.typeOfShortcut} onSelect={(value, item) => this.driveToShortcut(value, item.label)} block className="country-select" />
                            <this.Card link={this.state.typeOfShortcut === 'notification' ? "https://www.icloud.com/shortcuts/11935d1567444d6196028f833f205fdd" : 'https://www.icloud.com/shortcuts/f0cfbc60b53c4d86895a65d2bbe6dec7'} className="shortcut-lg-card shortcut-card" header="World 🌍" />
                        </div>
                        <div className="shortcut-mini-cards-container">
                            <this.Card link={this.state.typeOfShortcut === 'notification' ? 'https://www.icloud.com/shortcuts/9af3730fe37d4a698942a6dde6ce63a2' : 'https://www.icloud.com/shortcuts/0c225414a7bf430eb28ab6832af9bf11'} className="shortcut-sm-card shortcut-card" header="Italy 🇮🇹" />
                            <this.Card link={this.state.typeOfShortcut === 'notification' ? "https://www.icloud.com/shortcuts/363caf5072544c8f8192cf2e6502a065" : 'https://www.icloud.com/shortcuts/4b96ac2c3f5942c8aef64868fd9c4774'} className="shortcut-sm-card shortcut-card" header="UK 🇬🇧" />
                            <this.Card link={this.state.typeOfShortcut === 'notification' ? "https://www.icloud.com/shortcuts/ea139d37a6f5419cae9715bec2b1f8e3" : 'https://www.icloud.com/shortcuts/4e4ae622b34a4891a5aac82f8d632457'} className="shortcut-sm-card shortcut-card" header="USA 🇺🇸" />
                            <this.Card link={this.state.typeOfShortcut === 'notification' ? "https://www.icloud.com/shortcuts/b19339f8bfb0409a8ddc2239ef77cd44" : 'https://www.icloud.com/shortcuts/fcb23eed2a5a4ce297ff57b59f392842'} className="shortcut-sm-card shortcut-card" header="Spain 🇪🇸" />
                            <this.Card link={this.state.typeOfShortcut === 'notification' ? "https://www.icloud.com/shortcuts/006d75be462946afb6f5169784698712" : "https://www.icloud.com/shortcuts/c2eca581510f4cc19c0adaac88e6bb2d"} className="shortcut-sm-card shortcut-card" header="France 🇫🇷" />
                            <this.Card link={this.state.typeOfShortcut === 'notification' ? "https://www.icloud.com/shortcuts/be5795fa3a0f4249a61c8160c2809d21" : 'https://www.icloud.com/shortcuts/da75ead425904a9d96470594bca686e5'} className="shortcut-sm-card shortcut-card" header="Germany 🇩🇪" />
                        </div>
                    </div>

                </Content>
                <Footer style={{ marginTop: 50, marginBottom: 50, textAlign: 'center' }}>Made with ❤️ in Italy 🇮🇹   <ChatMeTwitter /><PrivacyLink/></Footer>
            </Container>
        )
    }
}